/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_New_Round_SubmitInputs */

const en_us2_clubs_new_round_submit = /** @type {(inputs: Clubs_New_Round_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start round`)
};

const pt_br2_clubs_new_round_submit = /** @type {(inputs: Clubs_New_Round_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar rodada`)
};

const es_419_clubs_new_round_submit = /** @type {(inputs: Clubs_New_Round_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar ronda`)
};

const pt_pt2_clubs_new_round_submit = /** @type {(inputs: Clubs_New_Round_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Começar ronda`)
};

const fr_fr2_clubs_new_round_submit = /** @type {(inputs: Clubs_New_Round_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lancer la manche`)
};

const de_de2_clubs_new_round_submit = /** @type {(inputs: Clubs_New_Round_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runde starten`)
};

const it_it2_clubs_new_round_submit = /** @type {(inputs: Clubs_New_Round_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia il turno`)
};

/**
* | output |
* | --- |
* | "Start round" |
*
* @param {Clubs_New_Round_SubmitInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_new_round_submit = /** @type {((inputs?: Clubs_New_Round_SubmitInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_New_Round_SubmitInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_new_round_submit(inputs)
	if (locale === "es-419") return es_419_clubs_new_round_submit(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_new_round_submit(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_new_round_submit(inputs)
	if (locale === "de-DE") return de_de2_clubs_new_round_submit(inputs)
	if (locale === "it-IT") return it_it2_clubs_new_round_submit(inputs)
	return en_us2_clubs_new_round_submit(inputs)
});
export { clubs_new_round_submit as "clubs.new_round_submit" }